import type { TablerIcon } from '@tabler/icons-react';

export type IconComponent = TablerIcon;

export const iconSizes = {
  inline: 16,
  control: 18,
  toolbar: 20,
  pageAction: 22,
  emptyState: 32,
} as const;

export type IconSizeRole = keyof typeof iconSizes;

/** Default stroke for Tabler outline icons. */
export const iconStroke = 1.8;
